<template>
  <input
    class="input-money"
    :class="customClass ? customClass : '' "
    :disabled="disabled ? true : false"
    :id="id ? id : ''"
    @keydown="allowNumbersOnlyAndMoveKey"
    :placeholder="placeholder ? placeholder : ''"
    :type="isPercent ? 'number' : 'text'"
    :value="formatMoneyNotUnit(value)"
    @input="inputValue"
    @change="
      ($event) => {
        ($event.target.value = formatMoneyNotUnit(value)), $emit('change');
      }
    "
  />
</template>

<script>
export default {
  props: [
    "value",
    "max",
    "min",
    "placeholder",
    "isPercent",
    "disabled",
    "id",
    "customClass",
  ],
  methods: {
    inputValue($event) {
      let value = this.checkNumReplaceCommaOld($event.target.value);
      const max = +this.max;
      const min = this.min ? +this.min : 0;
      if (max && value > max) {
        value = max;
      } else if (value < min) {
        value = min;
      }
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-money:disabled {
  background: #f2f2f2;
}
.input-money::placeholder {
  color: #c0c6d7;
}
.input-money.h-40 {
  height: 40px !important;
}
</style>
